export const imgPath = (path?: string) =>
  `https://arka-eg.com/public/upload${path ? "/" + path : ""}`;
// `https://react.hanstarcarrental.com/public/upload${path ? "/" + path : ""}`;
// `https://egyptos-travel.com/public/upload${path ? "/" + path : ""}`;
